<template>
  <v-form ref="form" v-model="valid" @submit.prevent="doSignup" lazy-validation>
    <v-card class="elevation-4">
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title>SIGN UP</v-toolbar-title>
        <v-spacer />
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-btn icon large :to="{ name: 'login' }" v-on="on">
              <v-icon>mdi-key</v-icon>
            </v-btn>
          </template>
          <span>Login</span>
        </v-tooltip>
      </v-toolbar>
      <v-progress-linear absolute indeterminate color="accent" height="7" v-if="loading"></v-progress-linear>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              label="First name"
              v-model="user.first_name"
              prepend-icon="mdi-account"
              type="text"
              :rules="nameRules"
              required
              validate-on-blur
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              label="Last name"
              v-model="user.last_name"
              type="text"
              :rules="nameRules"
              required
              validate-on-blur
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              label="Email"
              ref="email"
              v-model="userEmail"
              prepend-icon="mdi-email"
              type="text"
              :rules="emailRules"
              :error-messages="errors.email"
              required
              validate-on-blur
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              label="Cell"
              ref="cell"
              v-model="user.cell"
              prepend-icon="mdi-phone"
              type="text"
              :rules="[(v) => !!v || 'Cell is required']"
              :error-messages="errors.cell"
              required
              validate-on-blur
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <p class="body-1">
              Please read and accept our
              <router-link :to="{name: 'termsofservice'}">Terms of Service</router-link>.
            </p>
            <v-checkbox v-model="acceptTerms" label="Accept Terms of Service" :rules="termsRules"></v-checkbox>
            <p class="caption">Note: GroupBot is curently in beta.</p>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn class="ma-2" color="primary" type="submit" outlined :disabled="!valid">Sign up</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import { mapActions } from "vuex";
import { models } from "feathers-vuex";

export default {
  data: () => ({
    loading: false,
    valid: false,
    acceptTerms: false,
    user: {},
    errors: {},
    nameRules: [
      (v) => !!v || "First and last name is required",
      (v) => (v && v.length >= 3) || "Cannot be less than 3 characters",
    ],
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    termsRules: [
      (v) => v === true || "You must agree to the Terms of Service to sign up",
    ]
  }),
  mounted() {
    const { User } = models.api;
    const user = new User();
    this.user = user.clone();
  },
  computed: {
    userEmail: {
      get() {
        return this.user.email;
      },
      set(email) {
        this.user.email = email.toLowerCase();
      }
    },
    passwordConfirmationRules() {
      return [
        (v) => !!v || "Password confirmation is required",
        () =>
          this.user.password === this.user.password_confirmation ||
          "Password confirmation does not match password",
      ];
    },
  },
  methods: {
    ...mapActions("app", ["showMessage"]),
    validate() {
      return this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
      this.errors = {};
    },
    async doSignup() {
      if (!this.validate()) return;
      this.loading = true;
      try {
        await this.user.save();
        this.showMessage({ text: "Signed up successfully!", color: "success" });
        this.$router.push({
          name: "verify",
          query: { "signed-up": true, email: this.user.email },
        });
        this.loading = false;
      } catch (error) {
        this.errors = error.errors || error.data;
        this.loading = false;
      }
    },
  },
  watch: {
    user: {
      handler() {
        if (!this.valid) {
          this.resetValidation();
        }
      },
      deep: true,
    },
  },
};
</script>